/**
 * Checks if the given input is an instance of the Promise object
 */
const isPromise = (prom: any) => prom instanceof Promise;
export default isPromise;
